/**
 * 앱 진입 시 UTM 파라미터를 수집해 로거들에 주입한다.
 *
 * 부착 경로:
 *  - logger.setState: @zep/logger 의 singleton state에 utm을 병합.
 *    이후 logger.track()/debug() 호출 시 자동 병합되고, 내부 hyperdxLoggerWrapper.setState로
 *    hyperdx.setGlobalAttributes까지 자동 propagate되어 logger.captureError 같은
 *    error capture 경로까지 커버된다.
 *
 * TODO(utm-shared): packages/shared 출범 후 이 파일을 제거하고
 * @zep/shared/utm 으로 이관. web-app / play-app 2개 복사본 중복 상태.
 */
import { logger } from '@zep/core-logger';

import { getStoredUTMParams, getUTMParams, saveUTMParams } from './utmHelper';

// StrictMode 이중 render / router 재렌더 시 중복 실행 방어용 module-level flag.
let initialized = false;

export function initUtmTracking() {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;

  const fromUrl = getUTMParams();
  if (Object.values(fromUrl).some(Boolean)) {
    saveUTMParams(fromUrl);
  }

  const stored = getStoredUTMParams();
  const utm = Object.fromEntries(Object.entries(stored).filter(([, v]) => v));
  if (Object.keys(utm).length === 0) return;

  logger.setState(utm);
}
